export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mappingTable.worker.341ff421fbb06f47bc58.worker.js");
}
